import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import moment from "moment";
import defaultType1 from "../image/defaultType1.png"
import defaultType2 from "../image/defaultType2.png"

const Detail = (props) => {
  let data = props.data;
  let { atlasList } = data;
  const [index,setIndex]=useState(0)
  const [describe,setDescribe]=useState(atlasList[0].describe)
  const {publishPhoto, publishDate,variableFields,host} = data;
  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        height:"100%",
        flexDirection: "column",
        justifyContent: "space-between",
        backgroundColor: "#000"
      }}
    >
      <div
        style={{
          width: "100%",
          height: 50,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <span style={{ color: "#fff", fontSize: 16, fontWeight: "500" }}>
          {index + 1}/{atlasList.length}
        </span>
      </div>
      <Swiper
        onSlideChange={(e) =>{ 
            setIndex(e.activeIndex)
            setDescribe(atlasList[e.activeIndex].describe)}}
        style={{
          width: window.screen.width,
          maxWidth:677
        }}
      >
        {atlasList &&
          atlasList.map((item, index) => {
            return (
              <SwiperSlide>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "10px"
                  }}
                >
                  <img
                    src={host+ item.url}
                    style={{ width: "100%" }}
                    alt=""
                  />
                 
                </div>
              </SwiperSlide>
            );
          })}
      </Swiper>
      <div style={{ width: "100%", minHeight: 150 }}>
        <div style={{ display: "flex",marginLeft:12 }}>
          <img
            src={
              publishPhoto
                ? publishPhoto
                : variableFields && variableFields.publishType === 0
                ? defaultType1
                : defaultType2
            }
            style={{ width: 40, height: 40, verticalAlign: "middle" }}
            alt=""
          />
          <div
            style={{
              color: "#fff",
              display: "flex",
              flexDirection: "column",
              marginLeft: 6,
            }}
          >
            <span style={{ fontSize: 16, fontWeight: "500" }}>
              {variableFields.publishName}
            </span>
            <span style={{ fontSize: 12, fontWeight: "400" }}>
              {publishDate && moment(publishDate).format("YYYY-MM-DD")}
            </span>
          </div>
        </div>
        <div style={{padding:12}}>
        <p style={{ color: "#fff", fontSize: 14, fontWeight: "400" }}>
                    {describe}
                  </p>
        </div>
      </div>
    </div>
  );
};

export default Detail;
